import { api } from './client'

export type AiDraftChannel = 'email' | 'sms'
export type AiDraftStatus = 'suggested' | 'approved' | 'dismissed'

/** Mirrors backend AiSuggestionResponse. */
export interface AiSuggestion {
  id: string
  dealId: string
  contactId: string | null
  channel: AiDraftChannel
  subject: string | null
  body: string
  /** 'builtin' = in-platform template fallback; otherwise the AI service's model id. */
  model: string
  status: AiDraftStatus
  createdBy: string | null
  approvedAt: string | null
  dismissedAt: string | null
  createdAt: string
}

export interface CreateAiDraftInput {
  channel: AiDraftChannel
  instruction?: string | null
}

/** Optional agent edits applied just before the approved draft is sent. */
export interface ApproveAiDraftInput {
  subject?: string | null
  body?: string | null
}

export async function listAiDrafts(dealId: string): Promise<AiSuggestion[]> {
  const { data } = await api.get<AiSuggestion[]>(`/api/deals/${dealId}/ai-drafts`)
  return data
}

export async function createAiDraft(dealId: string, input: CreateAiDraftInput): Promise<AiSuggestion> {
  const { data } = await api.post<AiSuggestion>(`/api/deals/${dealId}/ai-drafts`, input)
  return data
}

export async function approveAiDraft(id: string, input: ApproveAiDraftInput): Promise<AiSuggestion> {
  const { data } = await api.post<AiSuggestion>(`/api/ai-drafts/${id}/approve`, input)
  return data
}

export async function dismissAiDraft(id: string): Promise<AiSuggestion> {
  const { data } = await api.post<AiSuggestion>(`/api/ai-drafts/${id}/dismiss`)
  return data
}
